export class OneboxActivation {
  keywords: string[] = [];
  regex = '';
  type = '';
}
